<template>
  <div class="filter-item">
    <!-- 这里触发点击事件 -->
    <el-button  
      v-for="item in buttonList"
      v-bind:key="item.id"
      v-if="item.BtnArea === 0"
      :type="item.Css"
      :icon="item.iconcss"
      @click="callFunc(item)"
      >{{ item.BtnName }}</el-button>
  </div>
</template>
<style lang="css">
@import "../style/content.css";
</style>
<script>
export default {
  name: "Toolbar",
  data() {
    return {
    };
  },
  props: ["buttonList"], //接受父组件传值
  methods: {
    callFunc(item) {
      this.$emit("callFunction", item); //将值传给父组件
    },
  },
};
</script>